/**
 * Karussell-Pfeile.
 *
 * Das Scrollen selbst macht CSS (scroll-snap) — ohne JavaScript bleibt die
 * Leiste wischbar und alle Karten erreichbar. Die Pfeile sind Komfort für
 * Maus und Tastatur und deaktivieren sich an den Enden.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;

    function step() {
      var item = track.querySelector('.carousel__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;

      /* Passt alles ohne Scrollen, braucht es die Pfeile nicht. */
      root.classList.toggle('carousel--static', max <= 1);
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  });
})();
